var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-solid/photo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.34315 3.34315 5 5 5H27C28.6569 5 30 6.34315 30 8V24C30 25.6569 28.6569 27 27 27H5C3.34315 27 2 25.6569 2 24V8ZM4 21.4142V24C4 24.5523 4.44772 25 5 25H27C27.5523 25 28 24.5523 28 24V21.4142L24.4142 17.8284C23.6332 17.0474 22.3668 17.0474 21.5858 17.8284L20.4142 19L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L13.4142 14.8284C12.6332 14.0474 11.3668 14.0474 10.5858 14.8284L4 21.4142ZM17.5 11C17.5 10.1716 18.1716 9.5 19 9.5C19.8284 9.5 20.5 10.1716 20.5 11C20.5 11.8284 19.8284 12.5 19 12.5C18.1716 12.5 17.5 11.8284 17.5 11Z",
    fill: "#5C41FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/ImageIcon.4391a921cbebc9b17a9741e0a70dc730.svg";
export { ForwardRef as ReactComponent };